export default {"headers":{"plural-forms":"nplurals=2; plural=(n > 1);","language":"en_CA@ashkenazi"},"contexts":{"":{"Tevet":["Teves"]}}}